"use strict";

exports.__esModule = true;
var _MTCDataTableElement = require("./MTCDataTableElement");
Object.keys(_MTCDataTableElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MTCDataTableElement[key]) return;
  exports[key] = _MTCDataTableElement[key];
});
var _MTCDataTableFields = require("./MTCDataTableFields");
Object.keys(_MTCDataTableFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MTCDataTableFields[key]) return;
  exports[key] = _MTCDataTableFields[key];
});
var _MTCDataTableThumbnail = require("./MTCDataTableThumbnail");
Object.keys(_MTCDataTableThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MTCDataTableThumbnail[key]) return;
  exports[key] = _MTCDataTableThumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});